import { useEffect, useReducer } from "react";

let deferred = null;
let installed = false;
const subscribers = new Set();
const notify = () => subscribers.forEach((fn) => fn());

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferred = e;
    notify();
  });
  window.addEventListener("appinstalled", () => {
    deferred = null;
    installed = true;
    notify();
  });
}

const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export function useInstallPrompt() {
  const [, rerender] = useReducer((x) => x + 1, 0);
  useEffect(() => {
    subscribers.add(rerender);
    return () => subscribers.delete(rerender);
  }, []);

  const mode = installed || isStandalone() ? "installed" : deferred ? "prompt" : isIOS() ? "ios" : "manual";
  const install = async () => {
    if (!deferred) return;
    const event = deferred;
    deferred = null;
    event.prompt();
    const { outcome } = await event.userChoice;
    if (outcome === "accepted") installed = true;
    notify();
  };
  return { mode, install };
}
